// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  visibleEngagementId: __t.string().primaryKey().name("visible_engagement_id"),
  playerId: __t.string().name("player_id"),
  matchId: __t.string().name("match_id"),
  engagementId: __t.string().name("engagement_id"),
  unitAId: __t.string().name("unit_a_id"),
  unitBId: __t.string().name("unit_b_id"),
  tickStarted: __t.u32().name("tick_started"),
  ticksActive: __t.u32().name("ticks_active"),
  directionOnA: __t.string().name("direction_on_a"),
  directionOnB: __t.string().name("direction_on_b"),
  damageAToB: __t.f64().name("damage_a_to_b"),
  damageBToA: __t.f64().name("damage_b_to_a"),
  moraleAToB: __t.f64().name("morale_a_to_b"),
  moraleBToA: __t.f64().name("morale_b_to_a"),
  outcome: __t.string(),
});
